<template>
<div id="product-top-serllers" class="menu">
    <h2 class="menu-label">{{title}}</h2>
    <ul class="menu-list" v-if="items && items.length > 0">
        <li v-for="item in items">
            <router-link class="columns is-marginless is-variable is-1" :to="item.url">
                <div class="column is-4">
                    <figure>
                        <img :src="item.thumb.url" />
                    </figure>
                </div>
                <div class="column">
                    <p class="subtitle">{{item.title}}</p>
                    <p class="prices title" v-if="!item.special_price">
                        <span class="price" itemprop="price">{{item.price.toDollar()}}</span>
                    </p>
                    <p class="prices title" v-else>
                        <span class="price" itemprop="price">{{item.special_price.toDollar()}}</span>
                        <span class="button is-rounded is-primary">{{item.discount_rate}}%</span>
                        <br /><strike class="price-was">{{item.price.toDollar()}}</strike>
                    </p>
                </div>
            </router-link>
        </li>
    </ul>
    <div class="menu-cta has-text-centered">
        <router-link class="button is-primary" :to="url">View All Best Sellers</router-link>
    </div>
</div>
</template>

<script>
export default {
    name    :   'ProductTopSellers',
    props   :   ['title', 'items', 'url']
}
</script>



// WEBPACK FOOTER //
// src/components/blocks/ProductTopSellers.vue